<form
  [formGroup]="grantLeavesForm"
  (ngSubmit)="grantLeaves()"
  class="tab-content"
>
  <div class="input-group">
    <label>{{ dictionaryService.get('Users') }}</label>
    <div class="input-wrapper">
      <app-select
        #usersSelect
        type="check"
        size="sm"
        [options]="users"
        [disableSearch]="true"
        (getCheckedItemsIds)="checkUser($event)"
        [isFullWidth]="true"
        [optionsIds]="usersIds"
        [allUncheckedInitially]="true"
      ></app-select>

      @if (f.usersIds.invalid && (f.usersIds.dirty || f.usersIds.touched)) {
        <small class="error-msg">
          {{ dictionaryService.get('UsersMissing') }}
        </small>
      }
    </div>
  </div>
  <div class="row-group">
    <div class="input-group">
      <label>{{ dictionaryService.get('Type') }}</label>
      <div class="input-wrapper">
        <app-select
          #typeSelect
          size="sm"
          [options]="leaveTypes"
          [disableSearch]="true"
          (getSelectedOption)="changeLeaveType($event)"
          [isFullWidth]="true"
        ></app-select>

        @if (
          f.leaveType.invalid && (f.leaveType.dirty || f.leaveType.touched)
        ) {
          <small class="error-msg">
            {{ dictionaryService.get('TypeMissing') }}
          </small>
        }
      </div>
    </div>

    <div class="input-group">
      <label for="subtype">{{ dictionaryService.get('Subtype') }}</label>
      <div class="input-wrapper">
        <input
          name="subtype"
          class="input"
          [placeholder]="dictionaryService.get('Subtype')"
          formControlName="subCategory"
          [class.invalid-input]="
            f.subCategory.invalid &&
            (f.subCategory.dirty || f.subCategory.touched)
          "
        />

        @if (
          f.subCategory.invalid &&
          (f.subCategory.dirty || f.subCategory.touched)
        ) {
          <small class="error-msg">
            {{ dictionaryService.get('SubtypeMissing') }}
          </small>
        }
      </div>
    </div>
  </div>

  <div class="row-group">
    <div class="input-group">
      <label for="from">{{ dictionaryService.get('From') }}</label>
      <div class="input-wrapper">
        <input
          name="from"
          formControlName="from"
          placeholder="{{ dictionaryService.get('ChooseFromDate') }}"
          type="date"
          class="input"
          [class.invalid-input]="
            f.from.invalid && (f.from.dirty || f.from.touched)
          "
        />

        @if (f.from.invalid && (f.from.dirty || f.from.touched)) {
          <small class="error-msg">
            {{ dictionaryService.get('FromMissing') }}
          </small>
        }
      </div>
    </div>
    <div class="input-group">
      <label for="to">{{ dictionaryService.get('To') }}</label>
      <div class="input-wrapper">
        <input
          name="to"
          formControlName="to"
          placeholder="{{ dictionaryService.get('ChooseToDate') }}"
          type="date"
          class="input"
          [class.invalid-input]="f.to.invalid && (f.to.dirty || f.to.touched)"
        />

        @if (f.to.invalid && (f.to.dirty || f.to.touched)) {
          <small class="error-msg">
            {{ dictionaryService.get('ToMissing') }}
          </small>
        }
      </div>
    </div>
  </div>

  <div class="input-group">
    <div class="checkbox-wrapper">
      <label for="isNonFieldActivity">{{
        dictionaryService.get('IsNonFieldActivity')
      }}</label>
      <input
        name="isNonFieldActivity"
        type="checkbox"
        formControlName="isNonFieldActivity"
      />
    </div>
  </div>

  <button
    buttonTheme="primary"
    buttonType="regular"
    class="w-100"
    type="submit"
  >
    {{ dictionaryService.get('Submit') }}
  </button>
</form>
